export default "__VITE_ASSET__Du61uNUv__"